export default __webpack_public_path__ + "static/media/history.dc1668fd.svg";